import React from 'react';
import { Upload } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { DraggerProps } from 'antd/lib/upload';
import { clsx } from 'clsx';
import { Icon } from '@common/components';

const { Dragger } = Upload;

type Props = DraggerProps & { hideActions?: boolean };

export const UploadDragger = ({
  className,
  multiple = false,
  hideActions = false,
  ...props
}: Props) => {
  const classes = clsx({
    'wk-upload-dragger': true,
    'wk-upload-dragger--single': !multiple,
    'wk-upload-dragger--hide-actions': hideActions,
  });

  return (
    <>
      <Dragger {...props} multiple={multiple} className={classes}>
        <Icon icon="cloudUpload" kind="regular" color="elmLighter" size="xxl" />
        <div className="wk-upload-dragger-message" data-testid="message">
          {`Click or drag ${multiple ? 'files' : 'a file'} to upload`}
        </div>
      </Dragger>
      <style jsx>{`
        :global(.wk-upload-dragger.ant-upload.ant-upload-drag) {
          background-color: ${Colors.elmHyperlight};
        }
        :global(.wk-upload-dragger.ant-upload.ant-upload-drag .ant-upload) {
          padding: 24px;
        }
        .wk-upload-dragger-message {
          color: ${Colors.elm};
          margin-top: 16px;
          font-weight: bold;
        }
        :global(.ant-upload.ant-upload-drag) {
          height: auto;
        }
        :global(
          .wk-upload-dragger.wk-upload-dragger--single
            + .ant-upload-list
            > div:not(:last-child)
        ) {
          display: none;
        }
        :global(
          .wk-upload-dragger--hide-actions
            + .ant-upload-list
            .ant-upload-list-item-card-actions
        ) {
          display: none;
        }
      `}</style>
    </>
  );
};
